import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Aguardando from '../common/template/aguardando';
import InputComprovante from '../common/form/inputComprovante';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import ButtonTable from '../common/table/buttonTable';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { baixarComprovante } from '../utils/comprovanteUtils';
import {
    getMinhaConta, getTipos, salvarMinhaDespesa,
    cancelarMinhaDespesa
} from './contaCorrenteFuncionarioActions';

const agora = new Date();
const moeda = valor => `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;
const data = valor => valor ? getDataHoraFormatada(valor, 'DD/MM/YYYY') : '-';
const hoje = () => {
    const valor = new Date();
    valor.setMinutes(valor.getMinutes() - valor.getTimezoneOffset());
    return valor.toISOString().substring(0, 10);
};
const novaDespesa = () => ({
    id_tipo_despesa: '', data: hoje(), valor: '', descricao: '',
    comprovante: null, comprovante_nome: null, comprovante_tipo: null
});

const MinhaContaCorrente = props => {
    const [filtros, setFiltros] = useState({
        ano: agora.getFullYear(), mes: agora.getMonth() + 1
    });
    const [formulario, setFormulario] = useState(null);
    const [aba, setAba] = useState('despesas');

    useEffect(() => {
        props.getMinhaConta(filtros);
        props.getTipos();
    }, []);

    const atualizar = () => props.getMinhaConta(filtros);
    const salvar = async evento => {
        evento.preventDefault();
        await props.salvarMinhaDespesa(formulario, filtros);
        setFormulario(null);
    };
    const conta = props.minhaConta;

    return <Content>
        <Aguardando aguardando={props.aguardando} />
        <ContentCard>
            <ContentCardHeader>
                <div className='row align-items-end'>
                    <div className='col-6 col-md-2 form-group mb-0'><label>Mês</label>
                        <select className='form-control' value={filtros.mes}
                            onChange={e => setFiltros({ ...filtros, mes: Number(e.target.value) })}>
                            {Array.from({ length: 12 }, (_, i) =>
                                <option value={i + 1} key={i + 1}>{i + 1}</option>)}
                        </select></div>
                    <div className='col-6 col-md-2 form-group mb-0'><label>Ano</label>
                        <input type='number' className='form-control' value={filtros.ano}
                            onChange={e => setFiltros({ ...filtros, ano: Number(e.target.value) })} /></div>
                    <div className='col-12 col-md-8 mt-2 mt-md-0'>
                        <button className='btn btn-primary' onClick={atualizar}>Atualizar</button>{' '}
                        <button className='btn btn-success' onClick={() => setFormulario(novaDespesa())}>
                            <i className='fas fa-plus' /> Lançar despesa
                        </button>
                    </div>
                </div>
            </ContentCardHeader>
            <ContentCardBody>
                {conta && <React.Fragment>
                    <div className='row'>
                        {[
                            ['Saldo inicial', conta.resumo.saldo_inicial],
                            ['Créditos', conta.resumo.creditos],
                            ['Despesas aprovadas', conta.resumo.despesas_aprovadas],
                            ['Saldo atual', conta.resumo.saldo_atual],
                            ['Despesas pendentes', conta.resumo.valor_pendente]
                        ].map(item => <div className='col-6 col-md' key={item[0]}>
                            <div className='small text-muted'>{item[0]}</div>
                            <strong>{moeda(item[1])}</strong>
                        </div>)}
                    </div>

                    {formulario && <form onSubmit={salvar}
                        className='card card-outline card-primary mt-3'>
                        <div className='card-body'>
                            <h5>{formulario.id ? 'Editar despesa' : 'Nova despesa'}</h5>
                            <div className='row'>
                                <div className='col-12 col-md-4 form-group'><label>Tipo *</label>
                                    <select required className='form-control'
                                        value={formulario.id_tipo_despesa}
                                        onChange={e => setFormulario({
                                            ...formulario, id_tipo_despesa: e.target.value
                                        })}>
                                        <option value=''>Selecione</option>
                                        {props.tipos.map(item => <option value={item.id} key={item.id}>{item.nome}</option>)}
                                    </select></div>
                                <div className='col-6 col-md-2 form-group'><label>Data *</label>
                                    <input required type='date' className='form-control'
                                        max={hoje()}
                                        value={formulario.data}
                                        onChange={e => setFormulario({ ...formulario, data: e.target.value })} /></div>
                                <LabelAndInputNumber
                                    name='valor_despesa'
                                    label='Valor *'
                                    cols='6 6 2 2'
                                    casas={2}
                                    value={formulario.valor}
                                    onChange={e => setFormulario({
                                        ...formulario,
                                        valor: e.target.value
                                    })}
                                />
                                <div className='col-12 col-md-4 form-group'><label>Descrição *</label>
                                    <input required className='form-control' value={formulario.descricao}
                                        onChange={e => setFormulario({ ...formulario, descricao: e.target.value })} /></div>
                                <div className='col-12'>
                                    <InputComprovante
                                        value={formulario.comprovante}
                                        nome={formulario.comprovante_nome}
                                        tipo={formulario.comprovante_tipo}
                                        onChange={arquivo => setFormulario({ ...formulario, ...arquivo })}
                                    />
                                </div>
                            </div>
                            <button className='btn btn-success'>Salvar</button>{' '}
                            <button type='button' className='btn btn-light'
                                onClick={() => setFormulario(null)}>Cancelar</button>
                        </div>
                    </form>}

                    <ul className='nav nav-tabs mt-3'>
                        <li className='nav-item'><button
                            className={`nav-link ${aba === 'despesas' ? 'active' : ''}`}
                            onClick={() => setAba('despesas')}>Despesas</button></li>
                        <li className='nav-item'><button
                            className={`nav-link ${aba === 'extrato' ? 'active' : ''}`}
                            onClick={() => setAba('extrato')}>Extrato</button></li>
                        <li className='nav-item'><button
                            className={`nav-link ${aba === 'acertos' ? 'active' : ''}`}
                            onClick={() => setAba('acertos')}>Acertos</button></li>
                    </ul>
                    {aba === 'despesas' && <div className='table-responsive mt-2'>
                        <table className='table table-sm table-striped'><thead><tr>
                            <th>Data</th><th>Tipo</th><th>Descrição</th><th className='text-right'>Valor</th>
                            <th>Status</th><th>Comprovante</th><th>Justificativa</th><th>Ações</th>
                        </tr></thead><tbody>{conta.despesas.map(item => <tr key={item.id}>
                            <td>{data(item.data)}</td><td>{item.nome_tipo_despesa}</td>
                            <td>{item.descricao}</td><td className='text-right'>{moeda(item.valor)}</td>
                            <td>{item.status}</td><td>{item.comprovante
                                ? <ButtonTable
                                    visible
                                    small
                                    type='info'
                                    icon='fas fa-download'
                                    title='Baixar comprovante'
                                    event={() => baixarComprovante(
                                        item.comprovante,
                                        item.comprovante_nome,
                                        item.comprovante_tipo
                                    )}
                                />
                                : '-'}</td><td>{item.justificativa_reprovacao || '-'}</td>
                            <td>{item.status === 'PENDENTE' && !item.id_abastecimento && <React.Fragment>
                                <ButtonTable
                                    visible
                                    small
                                    type='warning'
                                    icon='fas fa-pencil-alt'
                                    title='Editar'
                                    event={() => setFormulario({
                                        ...item,
                                        data: item.data
                                            .toString().substring(0, 10)
                                    })}
                                />
                                <ButtonTable
                                    visible
                                    small
                                    type='danger'
                                    icon='fas fa-ban'
                                    title='Cancelar'
                                    event={() =>
                                        window.confirm('Cancelar esta despesa?') &&
                                        props.cancelarMinhaDespesa(
                                            item.id,
                                            filtros
                                        )}
                                />
                            </React.Fragment>}</td>
                        </tr>)}</tbody></table>
                    </div>}
                    {aba === 'extrato' && <div className='table-responsive mt-2'>
                        <table className='table table-sm table-striped'><thead><tr>
                            <th>Data</th><th>Descrição</th><th className='text-right'>Crédito</th>
                            <th className='text-right'>Débito</th><th className='text-right'>Saldo</th>
                        </tr></thead><tbody>{conta.extrato.map(item => <tr key={item.id}>
                            <td>{data(item.data)}</td><td>{item.descricao}</td>
                            <td className='text-right'>{item.natureza === 'CREDITO' ? moeda(item.valor) : '-'}</td>
                            <td className='text-right'>{item.natureza === 'DEBITO' ? moeda(item.valor) : '-'}</td>
                            <td className='text-right'>{moeda(item.saldo_acumulado)}</td>
                        </tr>)}</tbody></table>
                    </div>}
                    {aba === 'acertos' && <table className='table table-sm mt-2'>
                        <thead><tr><th>Competência</th><th>Destinação</th><th className='text-right'>Saldo final</th></tr></thead>
                        <tbody>{conta.fechamentos.map(item => <tr key={item.id}>
                            <td>{String(item.mes).padStart(2, '0')}/{item.ano}</td>
                            <td>{item.tipo_destinacao}</td><td className='text-right'>{moeda(item.saldo_final)}</td>
                        </tr>)}</tbody>
                    </table>}
                </React.Fragment>}
            </ContentCardBody>
        </ContentCard>
    </Content>;
};

const mapState = state => ({ ...state.contaCorrenteFuncionario });
const actions = {
    getMinhaConta, getTipos, salvarMinhaDespesa, cancelarMinhaDespesa
};
export default connect(
    mapState,
    dispatch => bindActionCreators(actions, dispatch)
)(MinhaContaCorrente);
